// extracted by mini-css-extract-plugin
export default {"BladeContainer":"📚19-10-2M88DH","Blade":"📚19-10-2VsGfs"};